
import Card from 'vux/src/components/card/index.vue'
import Confirm from 'vux/src/components/confirm/index.vue'
import Previewer from 'vux/src/components/previewer/index.vue'
import Tab from 'vux/src/components/tab/tab.vue'
import Tabbar from 'vux/src/components/tabbar/tabbar.vue'
import TabbarItem from 'vux/src/components/tabbar/tabbar-item.vue'
import TabItem from 'vux/src/components/tab/tab-item.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'

import Addsaleslog from "./addsaleslog";
import Settinglogs from "./settinglogs";
import Searchlogs from "./searchlogs";

export default {
name: 'saleslog',
components: {Searchlogs, Settinglogs, Addsaleslog, Card, Confirm, Tab, TabItem, Tabbar, TabbarItem, Previewer},
directives: {
TransferDom
},
data() {
return {
remark: '',
showScore: false,
score: '',
imgList: [],
options: {
getThumbBoundsFn(index) {

let thumbnail = document.querySelectorAll('.previewer-demo-img')[index]

let pageYScroll = window.pageYOffset || document.documentElement.scrollTop


let rect = thumbnail.getBoundingClientRect()

return {x: rect.left, y: rect.top + pageYScroll, w: rect.width}


}
},
logid: '',
show: false,
infoTotal: 0,
infoList: [],
tabIndex: 0,
userid: '',
results: [],
value: '',
tabbarCheck: [true, false, false, false],
addInfo: {
date: '',
isEdit: '',
id: ''
},
start: '2020-01-01',
end: '2099-12-30',
isGetNewData: false,
SAVE_HEIGHT: 0,
index: 0,
height: 0
}
},
methods: {
showImg(pathList, infoindex, visitedindex, photoindex) {
this.imgList = this.infoList[infoindex].customer_visited[visitedindex].imgList
if (this.imgList[photoindex] && this.imgList[photoindex].hasOwnProperty('src')) {
this.$refs.previewer.show(photoindex)
return
}
const header = {
headers: {
token: localStorage.getItem('token'),
opid: localStorage.getItem('userid')
}
}
const path = this.infoList[infoindex].customer_visited[visitedindex].photos[photoindex]['origin']
this.$vux.loading.show({text: '加载中'})
this.$http.get('api/v1/photos?path=' + path, header).then(res => {
this.$vux.loading.hide();
if (this.imgList[photoindex]) {
this.imgList[photoindex].src = 'data:image/jpeg;base64,' + res.data['value']
} else {
this.$set(this.imgList, photoindex, {src: 'data:image/jpeg;base64,' + res.data['value']})
}
this.$refs.previewer.show(photoindex)
})
},
download({path, suffix}) {
this.$router.push({
name: "Download",
query: {path, suffix}
});
},
searchByUserid(userid) {
if (confirm('查看他的全部日志')) {
this.userid = userid
this.infoList = []
this.getReadData(0)
this.SAVE_HEIGHT = 0;
}
},
editAcreate() {
this.infoList = []
this.$set(this.tabbarCheck, 0, true)
this.$set(this.tabbarCheck, 1, false)
this.getData(0).then(() => {
let top = 0
for (let i = 0; i < this.index; i++) {
top += this.$refs.card[i].$el.offsetHeight
}
document.querySelector('#card-wrap').scrollTo({top})
this.getPhoto(this.index)
})
},
setting(num) {
switch (num) {
case 0:
this.switchTabItem(0)
break;
case 1:
const time = new Date()
this.addInfo.isEdit = ''
this.addInfo.date = time.getFullYear() + '-' + (time.getMonth() + 1) + '-' + time.getDate()
this.addInfo.id = ''
break;
}
this.tabbarCheck = this.tabbarCheck.map((item, index) => {
return (index === num)
})
},
search(event) {
this.userid = event.userid
this.start = event.start
this.end = event.end
this.infoList = []
this.$set(this.tabbarCheck, 0, true)
this.$set(this.tabbarCheck, 2, false)
this.tabIndex = 1
this.getReadData(0)
},
addcomment() {
const header = {
headers: {
token: localStorage.getItem('token'),
opid: localStorage.getItem('userid')
}
}
this.$http.post('/api/v1/sale_logs/' + this.logid + '/comment_salelog', {comment: this.value}, header).then(() => {
this.$vux.alert.show({
title: '',
content: '添加评论成功'
})
this.show = false
this.infoList = []
this.SAVE_HEIGHT = 0
this.height = 0
if (this.tabIndex === 0) {
this.getData(0).then(() => {
let top = 0
for (let i = 0; i < this.index; i++) {
top += this.$refs.card[i].$el.offsetHeight
}
document.querySelector('#card-wrap').scrollTo({top})
this.getPhoto(this.index)
})
} else if (this.tabIndex === 1) {
this.getReadData(0).then(() => {
let top = 0
for (let i = 0; i < this.index; i++) {
top += this.$refs.card[i].$el.offsetHeight
}
document.querySelector('#card-wrap').scrollTo({top})
this.getPhoto(this.index)
})
}
}).catch(error => {
this.$vux.alert.show({
title: '',
content: JSON.parse(error.response.data.error_message).zh_string
})
})
},
addScore() {
if (!this.score) {
alert('请添加分数')
return;
}
if ((parseFloat(this.score) <= 6 || parseFloat(this.score) >= 10) && !this.remark) {
alert('请添加评语')
return;
}
const header = {
headers: {
token: localStorage.getItem('token'),
opid: localStorage.getItem('userid')
}
}
this.$http.get('/api/v1/sale_logs/' + this.logid + '/salelog_leader_score_log?score=' + this.score + '&remark=' + this.remark, header).then(() => {
this.showScore = false
this.$vux.alert.show({
title: '',
content: '评分成功'
})
this.infoList = []
this.SAVE_HEIGHT = 0;
this.height = 0
if (this.tabIndex === 0) {
this.getData(0).then(() => {
let top = 0
for (let i = 0; i < this.index; i++) {
top += this.$refs.card[i].$el.offsetHeight
}
document.querySelector('#card-wrap').scrollTo({top})
this.getPhoto(this.index)
})
} else if (this.tabIndex === 1) {
this.getReadData(0).then(() => {
let top = 0
for (let i = 0; i < this.index; i++) {
top += this.$refs.card[i].$el.offsetHeight
}
document.querySelector('#card-wrap').scrollTo({top})
this.getPhoto(this.index)
})
}
}).catch(error => {
this.$vux.alert.show({
title: '',
content: JSON.parse(error.response.data.error_message).zh_string
})
})
},
getResult(val) {
const header = {
headers: {
token: localStorage.getItem('token'),
opid: localStorage.getItem('userid')
}
}
this.$http.get('/api/v1/agencies?task=ALL&offset=0&count=9999&hint=' + val, header).then(response => {
this.results = response.data.map(item => {
return {title: item.name, userid: item.userid}
})
})
},
resultClick(item) {
window.alert('you click the result item: ' + JSON.stringify(item))
},
switchTabItem(index) {
this.tabIndex = index
this.start = '2020-01-01'
this.end = '3000-12-30'
this.infoList = []
this.userid = ''
this.SAVE_HEIGHT = 0
this.height = 0
this.index = 0
switch (index) {
case 0:
this.getData(0)
break
case 1:
this.getReadData(0)
break
}
},
add(date, id, infoindex) {
this.addInfo.isEdit = date
this.addInfo.date = date
this.addInfo.id = id.toString()
this.tabbarCheck = this.tabbarCheck.map((item, index) => {
return (index === 1)
})
this.index = infoindex
},
async getReadData(offset) {
const header = {
headers: {
token: localStorage.getItem('token'),
opid: localStorage.getItem('userid')
}
}
const url = this.userid ? '&userid=' + this.userid : '';
const {
status,
data,
error
} = await this.$http.get('/api/v1/sale_logs/list_salelog_visible?offset=' + offset + '&count=99&start=' + this.start + '&end=' + this.end + url, header)
if (status !== 200) {
this.$vux.alert.show({
title: '',
content: JSON.parse(error.response.data.error_message).zh_string
})
} else {
/*for (const item of data.content) {
item.imgList = []
const res = await this.$http.get('/api/v1/sale_logs/' + item.id + '/list_salelog_visible_to?offset=0&count=9999', header)
res.data.content.forEach((item_item, index_index) => {
item.visiable = index_index ? item.visiable : []
if (!item_item.default) {
item.visiable.push(item_item)
}
})
item.userList = res.data.content.filter(item => {
return item.default
})
for (const visited of item.customer_visited) {
visited.imgList = []
if (visited.photos) {
for (const visitedElement of visited.photos) {
this.$http.get('api/v1/photos?path=' + visitedElement.thumb).then(photo => {
visited.imgList.push({msrc: 'data:image/jpeg;base64,' + photo.data['value']})
})
}
}
}
}*/
this.infoList = [...this.infoList, ...data.content.map(item => {
item.customer_visited.forEach(item => {
item.imgList = []
})
return item
})]
this.getPhoto(0).then()
this.infoTotal = data.total
this.isGetNewData = false
}
},
async getData(offset) {
const header = {
headers: {
token: localStorage.getItem('token'),
opid: localStorage.getItem('userid')
}
}
const {
status,
data,
error
} = await this.$http.get('/api/v1/sale_logs?offset=' + offset + '&count=99&start=2020-01-01&end=2999-12-31', header)
if (status !== 200) {
this.$vux.alert.show({
title: '',
content: JSON.parse(error.response.data.error_message).zh_string
})
} else {
this.infoList = [...this.infoList, ...data.content.map(item => {
item.customer_visited = item.customer_visited.map(item => {
return {...item, imgList: []}
})
return item
})]
this.getPhoto(0).then()
this.infoTotal = data.total
this.isGetNewData = false
}
},
async getPhoto(index) {
const item = this.infoList[index]
item.imgList = []
const header = {
headers: {
token: localStorage.getItem('token'),
opid: localStorage.getItem('userid')
}
}
if (this.tabIndex === 1) await this.$http.get('/api/v1/sale_logs/' + item.id + '/mark_salelog_read', header)
const res = await this.$http.get('/api/v1/sale_logs/' + item.id + '/list_salelog_visible_to?offset=0&count=9999', header)
res.data.content.forEach((item_item, index_index) => {
item.visiable = index_index ? item.visiable : []
if (!item_item.default) {
item.visiable.push(item_item)
}
})
item.userList = res.data.content.filter(item => {
return item.default
})
for (const visited of item.customer_visited) {
visited.imgList = []
if (visited.photos) {
for (const visitedElement of visited.photos) {
const photo = await this.$http.get('api/v1/photos?path=' + visitedElement.thumb)
visited.imgList.push({msrc: 'data:image/jpeg;base64,' + photo.data['value']})
}
}
}
this.$set(this.infoList, index, item)
}
},
created() {
const unionid = localStorage.getItem('unionid')
this.$http.get('api/v1/wechat/' + unionid).then((res) => {
let account;
if (res.data.length !== 0) {
res.data.forEach(item => {
if (item.role === 'SRVP') {
account = item.account;
}
});
if (!account) {
this.$vux.alert.show({
title: '',
content: '请绑定销售角色'
})
this.$router.push({name: 'vip'})
}
this.$http.post('api/v1/wechat/' + unionid + '/token', {'account': account}).then(response => {
localStorage.setItem('token', response.data.token)
localStorage.setItem('userid', response.data.userid)
this.getData(0)
})
}
})
},
mounted() {
let index = 0
const cardBox = document.querySelector('#card-wrap')
cardBox.addEventListener('scroll', () => {
if (this.SAVE_HEIGHT) {
if (cardBox.scrollTop < this.SAVE_HEIGHT) {
return
} else {
this.SAVE_HEIGHT = cardBox.scrollTop
}
} else {
this.SAVE_HEIGHT = cardBox.scrollTop
}
if (this.SAVE_HEIGHT === 0) return
if (this.height === 0) {
this.height += this.$refs.card[0].$el.offsetHeight;
index = 0
}
if (cardBox.scrollTop + cardBox.offsetHeight - this.height >= cardBox.offsetHeight / 2) {
index++
this.getPhoto(index).then()
this.height += this.$refs.card[index].$el.offsetHeight
}
if ((cardBox.scrollHeight <= cardBox.scrollTop + cardBox.clientHeight + 300) && this.infoList.length < this.infoTotal && !this.isGetNewData && this.tabbarCheck[0]) {

this.isGetNewData = true
switch (this.tabIndex) {
case 0:
this.getData(this.infoList.length)
break
case 1:
this.getReadData(this.infoList.length)
break
}
}

})
}
}



// WEBPACK FOOTER //
// ./src/components/Saleslog/index.vue